<ng-container *transloco="let _t">

<div class="selector">
	<button *ngIf="value==null && values.length>0" 
		mat-icon-button [title]="title" 
		(click)="opened=!opened">
		<mat-icon color="accent">filter_list</mat-icon>
	</button>

	<ul *ngIf="opened">
		<li *ngFor="let v of values" (click)="value = v; opened=false">{{v}}</li>
	</ul>

	<button *ngIf="value!=null" 
		mat-icon-button [title]="_t('filtered')+' : '+value+' - '+_t('delete-filter')"
		(click)="value=null">
		<mat-icon color="accent">close</mat-icon>
	</button>
</div>


</ng-container>